/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lessons_Format_Private_DurationInputs */

const en_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 or 60 min`)
};

const es_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 o 60 min`)
};

const de_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 oder 60 Min.`)
};

const zh_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 或 60 分钟`)
};

const ar_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 أو 60 دقيقة`)
};

const fr_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 ou 60 min`)
};

const vi_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 hoặc 60 phút`)
};

const sw_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dak 30 au 60`)
};

const th_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 หรือ 60 นาที`)
};

const bs_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 ili 60 min`)
};

const ja_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30分または60分`)
};

const ko_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30분 또는 60분`)
};

const pt_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 ou 60 min`)
};

const it_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 o 60 min`)
};

const sv_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 eller 60 min`)
};

const nl_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 of 60 min.`)
};

const da_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 eller 60 min.`)
};

const nb_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 eller 60 min`)
};

const fi_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 tai 60 min`)
};

const pl_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 lub 60 min`)
};

const ru_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 или 60 мин.`)
};

const tr_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 veya 60 dk`)
};

const hi_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 या 60 मिनट`)
};

const id_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 atau 60 menit`)
};

const ms_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 atau 60 minit`)
};

const cs_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 nebo 60 min.`)
};

const el_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 ή 60 λεπτά`)
};

const he_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 או 60 דקות`)
};

const af_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 of 60 min.`)
};

const hu_lessons_format_private_duration = /** @type {(inputs: Lessons_Format_Private_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`30 vagy 60 perc`)
};

/**
* | output |
* | --- |
* | "30 or 60 min" |
*
* @param {Lessons_Format_Private_DurationInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const lessons_format_private_duration = /** @type {((inputs?: Lessons_Format_Private_DurationInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lessons_Format_Private_DurationInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_lessons_format_private_duration(inputs)
	if (locale === "de") return de_lessons_format_private_duration(inputs)
	if (locale === "zh") return zh_lessons_format_private_duration(inputs)
	if (locale === "ar") return ar_lessons_format_private_duration(inputs)
	if (locale === "fr") return fr_lessons_format_private_duration(inputs)
	if (locale === "vi") return vi_lessons_format_private_duration(inputs)
	if (locale === "sw") return sw_lessons_format_private_duration(inputs)
	if (locale === "th") return th_lessons_format_private_duration(inputs)
	if (locale === "bs") return bs_lessons_format_private_duration(inputs)
	if (locale === "ja") return ja_lessons_format_private_duration(inputs)
	if (locale === "ko") return ko_lessons_format_private_duration(inputs)
	if (locale === "pt") return pt_lessons_format_private_duration(inputs)
	if (locale === "it") return it_lessons_format_private_duration(inputs)
	if (locale === "sv") return sv_lessons_format_private_duration(inputs)
	if (locale === "nl") return nl_lessons_format_private_duration(inputs)
	if (locale === "da") return da_lessons_format_private_duration(inputs)
	if (locale === "nb") return nb_lessons_format_private_duration(inputs)
	if (locale === "fi") return fi_lessons_format_private_duration(inputs)
	if (locale === "pl") return pl_lessons_format_private_duration(inputs)
	if (locale === "ru") return ru_lessons_format_private_duration(inputs)
	if (locale === "tr") return tr_lessons_format_private_duration(inputs)
	if (locale === "hi") return hi_lessons_format_private_duration(inputs)
	if (locale === "id") return id_lessons_format_private_duration(inputs)
	if (locale === "ms") return ms_lessons_format_private_duration(inputs)
	if (locale === "cs") return cs_lessons_format_private_duration(inputs)
	if (locale === "el") return el_lessons_format_private_duration(inputs)
	if (locale === "he") return he_lessons_format_private_duration(inputs)
	if (locale === "af") return af_lessons_format_private_duration(inputs)
	if (locale === "hu") return hu_lessons_format_private_duration(inputs)
	return en_lessons_format_private_duration(inputs)
});